import { apiFetch } from "./client";

export function startSession(slug, count) {
  return apiFetch("/api/bots/sessions", {
    method: "POST",
    body: { slug, count: Number(count) },
  });
}

export function listSessions() {
  return apiFetch("/api/bots/sessions");
}

export function sendCategory(sessionId, payload) {
  return apiFetch(`/api/bots/sessions/${sessionId}/send`, {
    method: "POST",
    body: payload,
  });
}

export function stopSession(sessionId) {
  return apiFetch(`/api/bots/sessions/${sessionId}/stop`, {
    method: "POST",
  });
}

export function listActions(sessionId) {
  return apiFetch(`/api/bots/sessions/${sessionId}/actions`);
}
